<template>
  <div v-if="!hasValue" class="d-flex flex-column align-start mb-4">
    <FieldLabel :text="label" />
    <p v-if="isImpactValidated" class="text-body-1 ma-0 pa-0">
      -
    </p>
    <v-chip v-else disabled small class="label mt-2">{{
      $t('common.in_progress_status')
    }}</v-chip>
  </div>
  <TimeImpactCard
    v-else
    data-private
    class="mb-2"
    :title="title"
    :imageUrl="monthly ? timeReductionImage : timeInvestedImage"
    :iconUrl="timeIcon"
    :timeUnit="timeUnit"
    :timeImpact="time"
  />
</template>
<script>
import _ from 'lodash'
import timeInvestedImage from '@/assets/rev/time_invested.svg'
import timeReductionImage from '@/assets/rev/time_reduction.svg'
import timeIcon from '@/assets/rev/time_icon.svg'
import FieldLabel from '@/components/Core/FieldLabel'
import TimeImpactCard from '@/components/Rev/Review/TimeImpact/TimeImpactCard.vue'

export default {
  name: 'TimeTrackingViewMode',

  components: {
    FieldLabel,
    TimeImpactCard,
  },

  props: {
    time: {
      required: false,
      type: Number,
    },
    timeUnit: {
      required: false,
      type: String,
    },
    monthly: {
      required: false,
      type: Boolean,
    },
    title: {
      required: false,
      type: String,
    },
    label: {
      required: false,
      type: String,
    },
    isImpactValidated: Boolean,
  },

  data() {
    return {
      timeInvestedImage,
      timeReductionImage,
      timeIcon,
    }
  },

  computed: {
    hasValue() {
      return _.isNumber(this.time) || _.isString(this.time)
    },
  },
}
</script>
